// Moving a player's progress from Safari into the home-screen app on iOS.
// The installed app starts with empty storage (no cookies, no localStorage, and
// iOS ignores a manifest changed after load), so the only bridge is a short
// one-time code: Safari uploads a snapshot, the app claims it.
// No 0/O or 1/I, so a code read off a screen can't be mistyped.
export const TRANSFER_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const TRANSFER_CODE_LENGTH = 8; // 32^8 ≈ 1e12: unguessable within the two days a code lives
export const TRANSFER_TTL_MS = 2 * 86_400_000;
export const TRANSFER_MAX_CHARS = 60_000;
export const TRANSFER_MAX_DAILY_RESULTS = 3;
// The only localStorage entries a transfer may carry: identity, progression and
// today's Daily result. Nothing else (session, telemetry queue, dismissals).
const TRANSFER_KEYS = [
    'bf_player_id', 'bf_display_name', 'bf_avatar', 'bf_profile', 'bf_achievements_init', 'bf_ratings', 'bf_muted',
];
export const TRANSFER_DAILY_PREFIX = 'bf_daily_result_';
export function isTransferKey(key) {
    return TRANSFER_KEYS.includes(key) || (key.startsWith(TRANSFER_DAILY_PREFIX) && key.length <= TRANSFER_DAILY_PREFIX.length + 12);
}
// Keeps only allowed keys with string values, and only the newest few Daily
// results (their keys end in a date, so they sort by day).
export function pickTransferData(entries) {
    const kept = {};
    for (const [key, value] of Object.entries(entries)) {
        if (typeof value === 'string' && isTransferKey(key))
            kept[key] = value;
    }
    const dailies = Object.keys(kept).filter(k => k.startsWith(TRANSFER_DAILY_PREFIX)).sort();
    for (const key of dailies.slice(0, Math.max(0, dailies.length - TRANSFER_MAX_DAILY_RESULTS)))
        delete kept[key];
    return kept;
}
export const TRANSFER_CODE_PATTERN = new RegExp(`^[${TRANSFER_CODE_ALPHABET}]{${TRANSFER_CODE_LENGTH}}$`);
// Accepts what people type or paste: any case, spaces, dashes.
export function normalizeTransferCode(input) {
    const code = input.toUpperCase().replace(/[^A-Z0-9]/g, '');
    return TRANSFER_CODE_PATTERN.test(code) ? code : null;
}
export const formatTransferCode = (code) => `${code.slice(0, 4)}-${code.slice(4)}`;
